/**
 * @generated SignedSource<<5f96d5dd4fad7ac494a7d531eb534b34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetEmailLayoutAsDefaultInput = {
  id: string;
};
export type SetEmailLayoutAsDefaultDialogMutation$variables = {
  input: SetEmailLayoutAsDefaultInput;
};
export type SetEmailLayoutAsDefaultDialogMutation$data = {
  readonly setEmailLayoutAsDefault: {
    readonly id: string;
    readonly isDefault: boolean;
  };
};
export type SetEmailLayoutAsDefaultDialogMutation = {
  response: SetEmailLayoutAsDefaultDialogMutation$data;
  variables: SetEmailLayoutAsDefaultDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailLayout",
    "kind": "LinkedField",
    "name": "setEmailLayoutAsDefault",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetEmailLayoutAsDefaultDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetEmailLayoutAsDefaultDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7370174af659117324e545b3fb2a9ad0",
    "id": null,
    "metadata": {},
    "name": "SetEmailLayoutAsDefaultDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SetEmailLayoutAsDefaultDialogMutation(\n  $input: SetEmailLayoutAsDefaultInput!\n) {\n  setEmailLayoutAsDefault(input: $input) {\n    id\n    isDefault\n  }\n}\n"
  }
};
})();

(node as any).hash = "adfda580985190f763f55ebfd74e44cd";

export default node;
